export default "__VITE_ASSET__573c1f98__"